import { render } from "./SettingsLabels.vue?vue&type=template&id=8b3fd95c"
import script from "./SettingsLabels.vue?vue&type=script&lang=js"
export * from "./SettingsLabels.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__